import { UserProfile } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.PROFILE.path,
      name: "Profile",
      key: routesMap.PROFILE.path,
      private: true,
      icon: routesMap.PROFILE.icon,
      belongsToSidebar: true,
      element: <UserProfile />,
    },
  ];
}
